@import ../../styles/helpers

.footerNav
    display: none
    width: 100%
    height: 60px
    position: fixed
    bottom: 0
    justify-content: space-around
    align-items: center
    background-color: $page_background
    border-top: 1px solid $bordercolor
    z-index: 20
    a
        height: 33px
        width: 33px
        img
            height: 100%
            width: auto
    .notification
        button
            width: 33px
            height: 33px
            img
                height: 100%
                width: auto
    +m
        display: flex
    
.user
    img
        height: 45px !important
        width: 45px !important
